import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaCheckCircle, FaTimesCircle, FaSpinner } from 'react-icons/fa';
import api from '../services/api';

// Page de vérification d'email. Lit ?token= dans l'URL et appelle
// GET /api/auth/verify-email. Trois états : chargement, succès, erreur/expiré.
const VerifyEmail = () => {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState('loading'); // loading | success | error

  useEffect(() => {
    if (!token) {
      setStatus('error');
      return;
    }
    let active = true;
    (async () => {
      try {
        await api.get('/api/auth/verify-email', { params: { token } });
        if (active) setStatus('success');
      } catch {
        if (active) setStatus('error');
      }
    })();
    return () => {
      active = false;
    };
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f5f7ff] to-[#faf8ff] flex flex-col items-center justify-center px-4">
      <div className="bg-white shadow-lg rounded-2xl p-8 w-full max-w-md text-center">
        {status === 'loading' && (
          <>
            <div className="text-4xl mx-auto mb-4 text-white bg-gradient-to-br from-purple-500 to-blue-500 rounded-full w-16 h-16 flex items-center justify-center">
              <FaSpinner className="animate-spin" />
            </div>
            <p className="text-gray-600">{t('emailAuth.verifyEmail.loading')}</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="text-4xl mx-auto mb-4 text-white bg-gradient-to-br from-green-500 to-emerald-500 rounded-full w-16 h-16 flex items-center justify-center">
              <FaCheckCircle />
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-2">
              {t('emailAuth.verifyEmail.successTitle')}
            </h1>
            <p className="text-gray-600 mb-6">{t('emailAuth.verifyEmail.successBody')}</p>
            <Link
              to="/signin"
              className="inline-block w-full py-2 text-white font-semibold rounded-md bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 transition"
            >
              {t('emailAuth.verifyEmail.goToSignin')}
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="text-4xl mx-auto mb-4 text-white bg-gradient-to-br from-red-500 to-rose-500 rounded-full w-16 h-16 flex items-center justify-center">
              <FaTimesCircle />
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-2">
              {t('emailAuth.verifyEmail.errorTitle')}
            </h1>
            <p className="text-gray-600 mb-6">{t('emailAuth.verifyEmail.errorBody')}</p>
            <Link
              to="/signin"
              className="inline-block w-full py-2 text-white font-semibold rounded-md bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 transition"
            >
              {t('emailAuth.verifyEmail.goToSignin')}
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
